import { setCookie, getCookie, clearAllCookies, doesCookieExist, removeCookie } from '../utils/cookies';

import axios from 'axios';
import {
    LOADING_TRUE,
    LOADING_FALSE,
    AUTHENTICATED_SUCCESS,
    AUTHENTICATED_FAIL,
    LOGIN_PROFILE,
    LOGOUT,
    APPEND_INDEX,
    LOGOUT_PROFILE,
    REMOVE_INDEX,
    RESET_STATE,
    ADD_TO_CALENDAR,
    REMOVE_FROM_CALENDAR,
    CALENDAR_CONFLICT_ERROR,
    REQUEST_PROCESSING,
    REQUEST_COMPLETED,
    SET_CURRENT_CLASSES,
    SET_CAMPUS,
    SHOW_INFO_FORM,
    HIDE_INFO_FORM,
    SET_YEAR,
    SET_PHONE,
    SET_CURRENT_CLASSES_DATA
} from './types';
import toast from 'react-hot-toast';

// Login Action
export const login = (navigate) => async (dispatch) => {
    // Start loading
    // dispatch({ type: LOADING_TRUE });

    try {
        // Set a session ID (replace with actual login API call in production)
        setCookie("session_id", "a3e44d7a-b16f-4eca-b0a2-57c3a582028e", { expires: 24 });

        // Dispatch successful authentication
        dispatch({ type: AUTHENTICATED_SUCCESS });

        // Navigate to dashboard after successful login
        window.location.reload();
        navigate("/dashboard");
    } catch (err) {
        console.error('Error during login:', err);
        // dispatch({ type: AUTHENTICATED_FAIL });
    } 
};


// Logout Action
export const logout = (navigate) => async (dispatch) => {
    // Start loading
    dispatch({ type: LOADING_TRUE });

    try {
        // Clear the session cookie
        removeCookie("session_id");
        document.cookie = "session_id=; path=/; domain=ruturbo.com; expires=Thu, 01 Jan 1970 00:00:00 UTC; Secure; SameSite=None";


        // Dispatch logout actions to update Redux state
        dispatch({ type: LOGOUT_PROFILE });
        dispatch({ type: LOGOUT });
        dispatch({type:RESET_STATE})

        // Add delay to keep the loading screen visible before navigating
        setTimeout(() => {
            // Navigate to the home page after logout
            navigate("/");

            // End loading once navigation is complete
            dispatch({ type: LOADING_FALSE });
        }, 500); // 10-second delay for the loading screen
        localStorage.clear();
    } catch (err) {
        console.error("Error during logout:", err);
        // Dispatch LOADING_FALSE in case of error to stop loading
        dispatch({ type: LOADING_FALSE });
        localStorage.clear();
    }
};




// Append Index Action
export const appendIndex = (indexes) => async (dispatch, getState) => {
    const currentState = getState();
    
    // Check if there's already a request in progress
    if (currentState.index.isProcessing) {
        toast.error(
            <div className="flex flex-col">
                <span className="text-lg font-bold">Request in Progress</span>
                <span className="text-sm">Please wait for the current request to complete</span>
            </div>,
            {
                duration: 4000,
                position: 'top-center',
                style: {
                    background: '#EF4444',
                    color: 'white',
                    padding: '16px',
                    borderRadius: '8px',
                    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                },
            }
        );
        return false;
    }

    const currentSniperIndexes = currentState.index.SniperIndexes;

    // Check for duplicates
    const duplicateIndexes = indexes.filter(index =>
        currentSniperIndexes.some(item => item.sectionIndex === index)
    );

    if (duplicateIndexes.length > 0) {
        toast.error(
            <div className="flex flex-col">
                <span className="text-lg font-bold">Already Sniping</span>
                <span className="text-sm">This course is already in your snipe list</span>
            </div>,
            {
                duration: 4000,
                position: 'top-center',
                style: {
                    background: '#EF4444',
                    color: 'white',
                    padding: '16px',
                    borderRadius: '8px',
                    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                },
            }
        );
        return false;
    }

    // Check sniper limit
    const currentSniperCount = currentSniperIndexes.length;
    const newIndexesCount = indexes.length;

    if (currentSniperCount + newIndexesCount > 7) {
        toast.error(
            <div className="flex flex-col">
                <span className="text-lg font-bold">Sniper Limit Reached</span>
                <span className="text-sm">You can only snipe up to 7 courses at a time</span>
            </div>,
            {
                duration: 4000,
                position: 'top-center',
                style: {
                    background: '#EF4444',
                    color: 'white',
                    padding: '16px',
                    borderRadius: '8px',
                    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                },
            }
        );
        return false;
    }

    // Set processing state to true
    dispatch({ type: REQUEST_PROCESSING });

    const configWithCampus = {
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            Authorization: getCookie('session_id'),
            campus: currentState.profile.campus || 'NB',
        },
    };

    const configWithoutCampus = {
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            Authorization: getCookie('session_id'),
        },
    };

    console.log('Current state campus:', currentState.profile.campus);
    console.log('Current state email:', currentState.profile.email);
    console.log('Config with campus headers:', configWithCampus.headers);

    // Show waiting notification
    const waitingToast = toast.loading(
        <div className="flex flex-col">
            <span className="text-lg font-bold">Processing Request</span>
            <span className="text-sm">Please wait while we process your request...</span>
        </div>,
        {
            position: 'top-center',
            style: {
                background: '#3B82F6',
                color: 'white',
                padding: '16px',
                borderRadius: '8px',
                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
            },
        }
    );

    try {
        // Call the API first - get_course_data needs campus in headers
        const body2 = JSON.stringify({
            indexes: indexes
        });
        console.log('Fetching course data for indexes:', indexes);
        const res3 = await axios.post("https://query.ruturbo.com/get_course_data", body2, configWithCampus);
        console.log('Course data received:', res3.data);
        
        res3.data.forEach((course) => {
            console.log('Dispatching APPEND_INDEX for course:', course);
            dispatch({
                type: APPEND_INDEX,
                payload: course
            });
        });

        if (res3.status === 200) {
            const body = JSON.stringify({
                email: currentState.profile.email,
                campus: currentState.profile.campus,
                index: indexes
            });

        console.log('Calling /index API with body:', body);
        
        // Use configWithoutCampus for /index since campus is in body
        const response = await axios.post('https://api.ruturbo.com/index', body, configWithoutCampus);
        console.log("AppendIndex API Response:", response.data);

        if (response.status === 200) {

            // Dismiss waiting toast and show success
            toast.dismiss(waitingToast);
            toast.success(
                <div className="flex flex-col">
                    <span className="text-lg font-bold">Success</span>
                    <span className="text-sm">Course successfully added to snipe list</span>
                </div>,
                {
                    duration: 4000,
                    position: 'top-center',
                }
            );
        }
    }
    } catch (err) {
        console.error('Error in appendIndex:', err);
        console.error('Error response:', err.response);
        
        // Dismiss waiting toast
        toast.dismiss(waitingToast);
        
        // Check if it's a 502 error for an already open index
        if (err.response && err.response.status === 502) {
            const errorMessage = err.response.data?.error || '';
            const indexMatch = errorMessage.match(/Index (\d+) is already open/);
            
            if (indexMatch) {
                const openIndex = indexMatch[1];
                toast.error(
                    <div className="flex flex-col">
                        <span className="text-lg font-bold">Course Already Open</span>
                        <span className="text-sm">Index {openIndex} has available seats. You can register directly!</span>
                    </div>,
                    {
                        duration: 5000,
                        position: 'top-center',
                        style: {
                            background: '#F59E0B',
                            color: 'white',
                            padding: '16px',
                            borderRadius: '8px',
                            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                        },
                    }
                );
                
                // Remove the course from Redux state since it was added but shouldn't be sniped
                indexes.forEach(index => {
                    dispatch({
                        type: REMOVE_INDEX,
                        payload: index
                    });
                });
            } else {
                // Generic 502 error
                toast.error(
                    <div className="flex flex-col">
                        <span className="text-lg font-bold">Server Error</span>
                        <span className="text-sm">Failed to add course to snipe list</span>
                    </div>,
                    {
                        duration: 4000,
                        position: 'top-center',
                        style: {
                            background: '#EF4444',
                            color: 'white',
                            padding: '16px',
                            borderRadius: '8px',
                            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                        },
                    }
                );
            }
        } else {
            // Other errors
            toast.error(
                <div className="flex flex-col">
                    <span className="text-lg font-bold">Error</span>
                    <span className="text-sm">Failed to add course to snipe list</span>
                </div>,
                {
                    duration: 4000,
                    position: 'top-center',
                    style: {
                        background: '#EF4444',
                        color: 'white',
                        padding: '16px',
                        borderRadius: '8px',
                        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                    },
                }
            );
        }
    } finally {
        // Set processing state to false
        dispatch({ type: REQUEST_COMPLETED });
    }
};

export const removeIndex = (num) => async (dispatch, getState) => {
    const currentState = getState();
    
    // Check if there's already a request in progress
    if (currentState.index.isProcessing) {
        toast.error(
            <div className="flex flex-col">
                <span className="text-lg font-bold">Request in Progress</span>
                <span className="text-sm">Please wait for the current request to complete</span>
            </div>,
            {
                duration: 4000,
                position: 'top-center',
                style: {
                    background: '#EF4444',
                    color: 'white',
                    padding: '16px',
                    borderRadius: '8px',
                    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                },
            }
        );
        return false;
    }

    // Set processing state to true
    dispatch({ type: REQUEST_PROCESSING });
    
    console.log("Removing index from Redux immediately", num);
    
    // Show waiting notification
    const waitingToast = toast.loading(
        <div className="flex flex-col">
            <span className="text-lg font-bold">Processing Request</span>
            <span className="text-sm">Please wait while we remove the course...</span>
        </div>,
        {
            position: 'top-center',
            style: {
                background: '#3B82F6',
                color: 'white',
                padding: '16px',
                borderRadius: '8px',
                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
            },
        }
    );

    // Dispatch Redux action to remove the item from the UI immediately
    dispatch({ type: REMOVE_INDEX, payload: num });

    const config = {
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': getCookie("session_id")
        }
    };
    const body = JSON.stringify({
        email: currentState.profile.email,
        index: [num], // pass the index as an array
        campus: currentState.profile.campus
    });

    try {
        console.log("Calling delete API");
        const response = await axios.post('https://api.ruturbo.com/deleteIndex', body, config);
        console.log("API Response:", response.data);
        
        // Dismiss waiting toast and show success
        toast.dismiss(waitingToast);
        toast.success(
            <div className="flex flex-col">
                <span className="text-lg font-bold">Success</span>
                <span className="text-sm">Course successfully removed from snipe list</span>
            </div>,
            {
                duration: 4000,
                position: 'top-center',
            }
        );
    } catch (err) {
        console.error('Error in RemoveIndex:', err);
        // Dismiss waiting toast and show error
        toast.dismiss(waitingToast);
        toast.error(
            <div className="flex flex-col">
                <span className="text-lg font-bold">Error</span>
                <span className="text-sm">Failed to remove course from snipe list</span>
            </div>,
            {
                duration: 4000,
                position: 'top-center',
                style: {
                    background: '#EF4444',
                    color: 'white',
                    padding: '16px',
                    borderRadius: '8px',
                    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                },
            }
        );
    } finally {
        // Set processing state to false
        dispatch({ type: REQUEST_COMPLETED });
    }
};

export const checkAuthStatus = (navigate, shouldNavigate = true) => async (dispatch, getState) => {
    try {
        const userName = getState().profile.userName;
        const isAuthenticated = getState().auth.isAuthenticated;

        if (doesCookieExist("session_id") && userName == null) {
            dispatch({ type: LOADING_TRUE });
            const session_id = getCookie("session_id");

            const config = {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': session_id
                },
                withCredentials: true,
            };

            console.log("CALLING API");

            const res = await axios.get("https://api.ruturbo.com/getinfo", config);
            console.log("DATA: ", res.data);

            dispatch({ type: AUTHENTICATED_SUCCESS });
            dispatch({ type: LOGIN_PROFILE, payload: res.data });

            // Check if mandatory fields are missing or null/N/A
            const { campus, year, Phone, CurrentClasses } = res.data;
            const isCampusMissing = !campus || campus === 'N/A' || campus === null;
            const isYearMissing = !year || year === 'N/A' || year === null;
            // Phone is now optional, so we don't check for it
            
            if (isCampusMissing || isYearMissing) {
                dispatch({ type: SHOW_INFO_FORM });
            }

            // Fetch current classes data if available
            if (CurrentClasses && Array.isArray(CurrentClasses) && CurrentClasses.length > 0) {
                const currentClassesConfig = {
                    ...config,
                    headers: {
                        ...config.headers,
                        campus: res.data.campus || null
                    }
                };
                const currentClassesBody = JSON.stringify({
                    indexes: CurrentClasses
                });
                const currentClassesResponse = await axios.post("https://query.ruturbo.com/get_course_data", currentClassesBody, currentClassesConfig);
                if (currentClassesResponse.status === 200 && currentClassesResponse.data) {
                    dispatch({
                        type: SET_CURRENT_CLASSES_DATA,
                        payload: currentClassesResponse.data
                    });
                }
            }

            // Extract and dispatch indexes
            const extractedIndexes = res.data.index || [];
            const body2 = JSON.stringify({
                indexes: extractedIndexes
            })

            const configWithCampus = {
                ...config,
                headers: {
                    ...config.headers,
                    campus: res.data.campus || null
                }
            };

            const res3 = await axios.post("https://query.ruturbo.com/get_course_data",body2, configWithCampus);
            res3.data.forEach((index) => {
                dispatch({
                    type: APPEND_INDEX,
                    payload: index
                });
            });
            const extractedIndexesCalendar = res.data.Calendar_Index || [];
            const body = JSON.stringify({
                indexes: extractedIndexesCalendar
            })

            const res2 = await axios.post("https://query.ruturbo.com/get_course_data",body, configWithCampus);
            console.log(" DATA FROM CALENDAR INDEXES : ",res2.data )
            res2.data.forEach((index) => {
                console.log("DATA IN WHILE: ",  index )
                dispatch({
                    type: ADD_TO_CALENDAR,
                    payload: index
                });
            });

            if (shouldNavigate) {
                setTimeout(() => {
                    navigate("/dashboard");
                }, 1000);
            }

            dispatch({ type: LOADING_FALSE });
            return { session_id: getCookie("session_id"), userData: res.data };
        } else if (!doesCookieExist("session_id")) {
            dispatch({ type: LOGOUT });
            dispatch({ type: LOGOUT_PROFILE });
            localStorage.clear();
            navigate("/");
        }
    } catch (err) {
        console.error('Error during auth status check:', err);
        dispatch({ type: AUTHENTICATED_FAIL });
        localStorage.clear();
    }
};



// Removed deprecated /threads endpoint and related functionality


export const appendToCalendar = (data) => async (dispatch, getState) => {
  try {
    const { CalendarIndexes } = getState().index;
    
    // Check for duplicates first
    const isDuplicate = CalendarIndexes.some(
      existingCourse => existingCourse.sectionIndex === data.sectionIndex
    );

    // Check calendar limit
    const isCalendarFull = CalendarIndexes.length >= 10;

    // If calendar is full, show that message regardless of duplicate status
    if (isCalendarFull) {
      toast.error(
        <div className="flex flex-col">
          <span className="text-lg font-bold">Calendar Full</span>
          <span className="text-sm">You can only add up to 10 courses to your calendar</span>
        </div>,
        {
          duration: 4000,
          position: 'top-center',
          style: {
            background: '#EF4444',
            color: 'white',
            padding: '16px',
            borderRadius: '8px',
            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
          },
        }
      );
      return false;
    }

    // If the section is already in calendar (and calendar isn't full)
    if (isDuplicate) {
      toast.error(
        <div className="flex flex-col">
          <span className="text-lg font-bold">Section Already Added</span>
          <span className="text-sm">This section is already in your calendar</span>
        </div>,
        {
          duration: 4000,
          position: 'top-center',
          style: {
            background: '#EF4444',
            color: 'white',
            padding: '16px',
            borderRadius: '8px',
            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
          },
        }
      );
      return false;
    }

    const currentState = getState();
    const config = {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: getCookie('session_id'),
      },
    };

    const body = JSON.stringify({
      email: currentState.profile.email,
      indexes: [data.sectionIndex]
    });

    // Make the API call first
    const res = await axios.post("https://api.ruturbo.com/add_calendar_index", body, config);
    
    // If API call is successful, add to Redux
    dispatch({
      type: ADD_TO_CALENDAR,
      payload: data
    });

    console.log('Added to Calendar:', data);
    return true;

  } catch (error) {
    console.error('Error adding to calendar:', error);
    dispatch({
      type: CALENDAR_CONFLICT_ERROR,
      payload: 'Error adding course to calendar'
    });
    return false;
  }
};

// Add new action to remove course from calendar
export const removeFromCalendar = (sectionIndex) => async (dispatch, getState) => {
    const currentState = getState();
    const config = {
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          Authorization: getCookie('session_id'), // Ensure `getCookie` is defined elsewhere
        },
      };
    try {
        const body = JSON.stringify({
            email: currentState.profile.email,
            indexes: [sectionIndex]
        })
        // Check if the index is in SniperIndexes
        const { SniperIndexes } = getState().index;
        const isBeingSniped = SniperIndexes.some(item => item.index === sectionIndex);

        // Only call delete API if the index is being sniped
        dispatch({
            type: REMOVE_FROM_CALENDAR,
            payload: sectionIndex
        });
        const res = await axios.post("https://api.ruturbo.com/delete_calendar_index", body, config);

        if (isBeingSniped) {
           
            // Remove from snipe list
            dispatch({
                type: REMOVE_INDEX,
                payload: sectionIndex
            });
            removeIndex(sectionIndex)
        }

        // Always remove from calendar
       
    } catch (err) {
        console.error('Error removing course:', err);
    }
};

export const addToCalendar = (course) => async (dispatch, getState) => {
  try {
    // Check if the course is already in CalendarIndexes
    const { CalendarIndexes } = getState().index;
    const isDuplicate = CalendarIndexes.some(
      existingCourse => existingCourse.sectionIndex === course.sectionIndex
    );

    if (isDuplicate) {
      dispatch({
        type: CALENDAR_CONFLICT_ERROR,
        payload: 'This section is already in your calendar'
      });
      return false;
    }

    // If not a duplicate, proceed with adding to calendar
    dispatch({
      type: ADD_TO_CALENDAR,
      payload: course
    });
    return true;

  } catch (error) {
    dispatch({
      type: CALENDAR_CONFLICT_ERROR,
      payload: 'Error adding course to calendar'
    });
    return false;
  }
};

export const clearCalendar = () => async (dispatch, getState) => {
  const currentState = getState();
  const config = {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: getCookie('session_id'),
    },
  };

  try {
    const body = JSON.stringify({});

    // Call API to clear calendar
    dispatch({ type: 'CLEAR_CALENDAR' });
    
    await axios.post("https://api.ruturbo.com/clear_calendar", body, config);

    // Dispatch action to clear calendar in Redux
    

  } catch (error) {
    console.error('Error clearing calendar:', error);
  }
};

// Action to set current classes
export const setCurrentClasses = (currentClasses) => ({
    type: SET_CURRENT_CLASSES,
    payload: currentClasses
});

// Action to set campus
export const setCampus = (campus) => ({
    type: SET_CAMPUS,
    payload: campus
});

// Fetch current classes data
export const fetchCurrentClassesData = () => async (dispatch, getState) => {
    try {
        const currentState = getState();
        const currentClasses = currentState.profile.currentClasses;
        
        // Only fetch if we have current classes indexes
        if (!currentClasses || !Array.isArray(currentClasses) || currentClasses.length === 0) {
            return;
        }

        const config = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': getCookie('session_id'),
                campus: currentState.profile.campus || null
            },
            withCredentials: true,
        };

        const body = JSON.stringify({
            indexes: currentClasses
        });

        const response = await axios.post("https://query.ruturbo.com/get_course_data", body, config);
        
        if (response.status === 200 && response.data) {
            dispatch({
                type: SET_CURRENT_CLASSES_DATA,
                payload: response.data
            });
        }
    } catch (err) {
        console.error('Error fetching current classes data:', err);
    }
};

// Refresh user profile and current classes data after schedule update
export const refreshUserProfileData = () => async (dispatch, getState) => {
    try {
        const session_id = getCookie("session_id");
        if (!session_id) {
            throw new Error('No session found');
        }

        const config = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': session_id
            },
            withCredentials: true,
        };

        console.log("Refreshing user profile data...");

        // Get updated user info including current classes indexes
        const res = await axios.get("https://api.ruturbo.com/getinfo", config);
        console.log("Updated user data: ", res.data);

        // Update profile data in Redux
        dispatch({ type: LOGIN_PROFILE, payload: res.data });

        // Fetch detailed current classes data if available
        if (res.data.CurrentClasses && Array.isArray(res.data.CurrentClasses) && res.data.CurrentClasses.length > 0) {
            console.log("Fetching detailed current classes data for indexes:", res.data.CurrentClasses);
            
            const currentClassesConfig = {
                ...config,
                headers: {
                    ...config.headers,
                    campus: res.data.campus || null
                }
            };
            
            const currentClassesBody = JSON.stringify({
                indexes: res.data.CurrentClasses
            });
            
            const currentClassesResponse = await axios.post("https://query.ruturbo.com/get_course_data", currentClassesBody, currentClassesConfig);
            
            if (currentClassesResponse.status === 200 && currentClassesResponse.data) {
                console.log("Current classes detailed data:", currentClassesResponse.data);
                dispatch({
                    type: SET_CURRENT_CLASSES_DATA,
                    payload: currentClassesResponse.data
                });
            }
        } else {
            // Clear current classes data if no classes found
            dispatch({
                type: SET_CURRENT_CLASSES_DATA,
                payload: []
            });
        }

        console.log("User profile data refreshed successfully");
        return true;
    } catch (err) {
        console.error('Error refreshing user profile data:', err);
        throw err;
    }
};

// Update user information action
export const updateUserInfo = (userInfo) => async (dispatch, getState) => {
    try {
        const config = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': getCookie('session_id')
            },
            withCredentials: true,
        };

        const currentState = getState();
        
        // Build the payload - only include phone if it's provided and not empty
        const payload = {
            campus: userInfo.campus,
            Year: userInfo.year,
            username: currentState.profile.userName
        };
        
        // Only add phone if it's provided and not empty/N/A
        if (userInfo.phone && userInfo.phone.trim() !== '' && userInfo.phone.trim() !== 'N/A') {
            payload.Phone = userInfo.phone;
        }
        
        // Add phone preferences if provided
        if (userInfo.text !== undefined) {
            payload.Text = userInfo.text;
        }
        if (userInfo.call !== undefined) {
            payload.Calling = userInfo.call;
        }
        
        const body = JSON.stringify(payload);

        const res = await axios.post("https://api.ruturbo.com/updateinfo", body, config);
        
        if (res.status === 200) {
            // Update Redux state with new information
            dispatch({ type: SET_CAMPUS, payload: userInfo.campus });
            dispatch({ type: SET_YEAR, payload: userInfo.year });
            
            // Only update phone if it's provided and not N/A
            if (userInfo.phone && userInfo.phone.trim() !== '' && userInfo.phone.trim() !== 'N/A') {
                dispatch({ type: SET_PHONE, payload: userInfo.phone });
            }
            
            // Hide the info form
            dispatch({ type: HIDE_INFO_FORM });
            
            toast.success(
                <div className="flex flex-col">
                    <span className="text-lg font-bold">Profile Updated</span>
                    <span className="text-sm">Your information has been successfully updated</span>
                </div>,
                {
                    duration: 4000,
                    position: 'top-center',
                }
            );
            
            return true;
        }
    } catch (err) {
        console.error('Error updating user info:', err);
        toast.error(
            <div className="flex flex-col">
                <span className="text-lg font-bold">Update Failed</span>
                <span className="text-sm">Failed to update your information. Please try again.</span>
            </div>,
            {
                duration: 4000,
                position: 'top-center',
                style: {
                    background: '#EF4444',
                    color: 'white',
                    padding: '16px',
                    borderRadius: '8px',
                    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                },
            }
        );
        return false;
    }
};
// Process extracted schedule and add courses to calendar
export const processExtractedSchedule = (currentClasses) => async (dispatch, getState) => {
    try {
        const currentState = getState();
        const campus = currentState.profile.campus;
        
        console.log('Processing extracted schedule:', currentClasses);
        console.log('Current campus:', campus);
        
        if (!campus) {
            console.error('Campus not set in state');
            return false;
        }

        const config = {
            headers: {
                'Content-Type': 'application/json',
                'campus': campus
            },
            withCredentials: true,
        };

        // The API expects indexes as an array of strings
        const body = JSON.stringify({ indexes: currentClasses });

        // Fetch course data for the extracted indexes
        const res = await axios.post("https://query.ruturbo.com/get_course_data", body, config);
        
        console.log('Course data received:', res.data);
        
        if (res.data && Array.isArray(res.data)) {
            // Store the current classes index IDs
            console.log('Dispatching SET_CURRENT_CLASSES with:', currentClasses);
            dispatch({
                type: SET_CURRENT_CLASSES,
                payload: currentClasses
            });

            // Update the current classes data in profile state
            console.log('Dispatching SET_CURRENT_CLASSES_DATA with:', res.data);
            dispatch({
                type: SET_CURRENT_CLASSES_DATA,
                payload: res.data
            });

            toast.success(
                <div className="flex flex-col">
                    <span className="text-lg font-bold">Schedule Loaded</span>
                    <span className="text-sm">{currentClasses.length} course(s) added to your schedule</span>
                </div>,
                {
                    duration: 4000,
                    position: 'top-center',
                }
            );

            return true;
        }
    } catch (err) {
        console.error('Error processing extracted schedule:', err);
        toast.error(
            <div className="flex flex-col">
                <span className="text-lg font-bold">Failed to Load Schedule</span>
                <span className="text-sm">Could not add courses to calendar. Please try again.</span>
            </div>,
            {
                duration: 4000,
                position: 'top-center',
                style: {
                    background: '#EF4444',
                    color: 'white',
                    padding: '16px',
                    borderRadius: '8px',
                    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                },
            }
        );
        return false;
    }
};
